import { ApiService, toData } from '~/shared/api'
import type { ApiDataResponse } from '~/shared/types/api'
import type { WorkCard } from '~/types/work-card'

type WorkCardsResponse = ApiDataResponse<WorkCard[]>

export class WorkCardsService extends ApiService {
  readonly urls = {
    workCards: '/api/v1/yavagro/index-page-counts',
  }

  public getWorkCardsList(): Promise<WorkCard[]> {
    return this.http.request<WorkCardsResponse>({ url: this.urls.workCards }).then(toData())
  }
}
